import { useContext, useMemo } from "react";

import AllPhotoUploadsContext from "../context/AllPhotoUploadsContext";

const usePhotoUploadsInDropzone = () => {
    const context = useContext(AllPhotoUploadsContext);

    if (context === undefined) {
        throw new Error(
            "usePhotoUploadsInDropzone must be used within an AllPhotoUploadsProvider"
        );
    }

    const {
        uploadsData: data,
        fetchUploadsInDropzone,
        refetchUploadsInDropzone,
        uploadsInDropzoneQueryCalled,
        uploadsInDropzoneLoading
    } = context;

    const getUploads = () => {
        const uploads =
            (data && data.listPhotoUploads && data.listPhotoUploads.items) ||
            [];

        return uploads.sort((a, b) => a.id - b.id);
    };

    const uploads = useMemo(getUploads, [data]);
    const uploadIds = useMemo(() => uploads.map(upload => upload.id), [data]);

    const uploadCount =
        (data &&
            data.listPhotoUploads &&
            data.listPhotoUploads &&
            data.listPhotoUploads.totalCount) ||
        0;

    const getUploadData = uploadId =>
        uploads.find(upload => upload.id === uploadId);

    const getDataForUploads = uploadIds => {
        if (!Array.isArray(uploadIds)) {
            return console.warn(
                "Please pass an array of upload ids to getDataForUploads"
            );
        }

        const data = [];

        uploadIds.forEach(uploadId => {
            const uploadData = getUploadData(uploadId);

            if (!!uploadData) {
                if (uploadData.status === "IN_DROPZONE") {
                    data.push(uploadData);
                }
            }
        });

        return data;
    };

    return {
        fetchUploads: fetchUploadsInDropzone,
        getUploadData: getUploadData,
        getDataForUploads,
        uploadIds,
        uploadCount,
        uploads,
        refetch: refetchUploadsInDropzone,
        dataLoaded: uploadsInDropzoneQueryCalled && !uploadsInDropzoneLoading
    };
};

export default usePhotoUploadsInDropzone;
